export const imageFallback = "/fallbacks/imageNotFound.png";

export const imageLoadingPlaceholder =
  "/fallbacks/image-loading-placeholder.jpg";
